import { Particle, type ParticleOptions } from "../Particle";
import { MovesDown } from "../behaviors/MovesDown";
import { PhaseChange } from "../behaviors/PhaseChange";
import { TemperatureNormalization } from "../behaviors/TemperatureNormalization";
import { Lava } from "./Lava";
import { adjustColor } from "../../utils/color";

export class Gravel extends Particle {
    static baseColor = 0x707070; // Darker Grey than Stone

    constructor(options: Partial<ParticleOptions> = {}) {
        super({
            name: "Gravel",
            color: adjustColor(Gravel.baseColor, 20),
            behaviors: [
                new MovesDown(), // 像沙子一样下落
                new PhaseChange([
                    { temp: 1000, type: 'above', factory: () => new Lava({ temperature: 1000 }) }
                ]),
                new TemperatureNormalization(20, 0.1)
            ],
            props: { isMixable: true, thermalConductivity: 0.1, isPowder: true }, // 导热比整块石头稍好
            temperature: 20,
            minTemp: -273,
            maxTemp: 3000,
            ...options
        });
    }
}
